module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "hidden"
  }, [_c('ImageMesh', {
    ref: "menu-open",
    attrs: {
      "vms": "@menu@menu-trigger",
      "d-gclick": "() => { showFSMenu = !showFSMenu; }",
      "link": require('./img/menu-open.png')
    }
  }), _vm._v(" "), _c('GrungeMesh', {
    ref: "menu-gradient",
    attrs: {
      "depthTest": false,
      "blending": _vm.THREE.AdditiveBlending,
      "vms": "@menu@red-gradient",
      "opacity": 0.5,
      "gclick": function () {},
      "link": require('./img/red-gradient.svg')
    },
    on: {
      "exec": function (v) {
        _vm.execStack.red = v
      }
    }
  }), _vm._v(" "), _c('Mesh', {
    ref: "red-box",
    attrs: {
      "gclick": function () {
        _vm.showFSMenu = !_vm.showFSMenu;
      },
      "position": {
        x: 32.5 * _vm.aspect,
        y: 35.2,
        z: 0.3
      }
    }
  }, [_c('PlaneGeometry', {
    attrs: {
      "width": 6,
      "height": 6
    }
  }), _vm._v(" "), _c('MeshBasicMaterial', {
    attrs: {
      "opacity": 0.0,
      "color": 0x000000
    }
  })], 1), _vm._v(" "), _c('transition', {
    on: {
      "enter": _vm.menuIn,
      "leave": _vm.menuOut
    }
  }, [_c('keep-alive', [(!_vm.showFSMenu) ? _c('Object3D', {
    ref: "nav-bar",
    attrs: {
      "position": {
        x: 0,
        y: 35.2,
        z: 0
      }
    }
  }, [_c('ImageMesh', {
    ref: "nike-logo",
    attrs: {
      "vms": "@menu@nike-logo",
      "aspect": _vm.aspect,
      "gclick": function (v) {
        _vm.$router.push('/nike/game')
      },
      "d-position": {
        x: -22.5 * _vm.aspect,
        y: 0,
        z: 0
      },
      "d-scale": {
        x: 1 / 3,
        y: 1 / 3,
        z: 1.0
      },
      "link": require('./img/nike.png')
    }
  }), _vm._v(" "), _c('Mesh', {
    ref: "nav-red-line",
    attrs: {
      "position": {
        x: 0,
        y: -3.3,
        z: 0.3
      }
    }
  }, [_c('PlaneGeometry', {
    attrs: {
      "width": 55,
      "height": 0.2
    }
  }), _vm._v(" "), _c('MeshBasicMaterial', {
    attrs: {
      "opacity": 1,
      "color": 0xee3932
    }
  })], 1), _vm._v(" "), _c('Mesh', {
    ref: "nav-grey-box",
    attrs: {
      "position": {
        x: 0,
        y: 0,
        z: 0.06
      }
    }
  }, [_c('PlaneGeometry', {
    attrs: {
      "width": 55,
      "height": 6.45
    }
  }), _vm._v(" "), _c('MeshBasicMaterial', {
    attrs: {
      "opacity": 0.7,
      "blending": _vm.THREE.NormalBlending,
      "color": 0x010101
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('transition', {
    on: {
      "enter": _vm.fsMenuIn,
      "leave": _vm.fsMenuOut
    }
  }, [_c('keep-alive', [(_vm.showFSMenu) ? _c('Object3D', {
    ref: "fs-menu",
    attrs: {
      "position": {
        x: 0,
        y: 0,
        z: 0.1
      }
    }
  }, [_c('Mesh', {
    ref: "nav-grey-box-2",
    attrs: {
      "position": {
        x: 0,
        y: 0,
        z: 0.05
      }
    }
  }, [_c('PlaneGeometry', {
    attrs: {
      "width": 55,
      "height": 155
    }
  }), _vm._v(" "), _c('MeshBasicMaterial', {
    attrs: {
      "opacity": 0.85,
      "blending": _vm.THREE.NormalBlending,
      "color": 0x010101
    }
  })], 1), _vm._v(" "), _c('GrungeMesh', {
    attrs: {
      "vms": "@menu@content@grunge@menu-bg",
      "gclick": function () {}
    },
    on: {
      "exec": function (v) {
        if (_vm.showFSMenu) {
          _vm.execStack.grungeCouponBox = v;
        }
      }
    }
  }), _vm._v(" "), _c('ImageMesh', {
    ref: "fs-menu-close",
    attrs: {
      "vms": "@menu@fs-menu-close",
      "gclick": function () {
        if (_vm.showFSMenu || !_vm.tweening) {
          _vm.showFSMenu = !_vm.showFSMenu;
        }
      },
      "link": require('./img/red-btn.png')
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "vms": "@menu@items@home",
      "gclick": function () {
        if (_vm.showFSMenu) {
          _vm.showFSMenu = !_vm.showFSMenu;
          _vm.$router.push('/nike/game');
        }
      },
      "link": require('./img/items/home.png')
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "vms": "@menu@items@boxing-camp",
      "gclick": function () {
        if (_vm.showFSMenu) {
          _vm.showFSMenu = !_vm.showFSMenu;
          _vm.$router.push('/nike/game/agree');
        }
      },
      "scale": {
        x: 0.5,
        y: 0.5,
        z: 1.0
      },
      "link": require('./img/items/boxing-camp.png')
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "vms": "@menu@items@rules",
      "gclick": function () {
        if (_vm.showFSMenu) {
          _vm.showFSMenu = !_vm.showFSMenu;
          _vm.$router.push('/nike/game/rules');
        }
      },
      "link": require('./img/items/rules.png')
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "vms": "@menu@items@rewards",
      "gclick": function () {
        if (_vm.showFSMenu) {
          _vm.showFSMenu = !_vm.showFSMenu;
          _vm.$router.push('/nike/game/status');
        }
      },
      "aspect": _vm.aspect,
      "link": require('./img/items/rewards.png')
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "vms": "@menu@items@comics",
      "gclick": function () {
        if (_vm.showFSMenu) {
          _vm.showFSMenu = !_vm.showFSMenu;
          _vm.$router.push('/nike/game/comic-list');
        }
      },
      "aspect": _vm.aspect,
      "link": require('./img/items/comics.png')
    }
  })], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40c031f7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NikeWebGL/element/Menu/Menu.vue
// module id = 586
// module chunks = 0